/**
 * @generated SignedSource<<e2ea9e58cd18e0ef1b86aada6a8f9cd3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateParticipantMutation$variables = {
  age?: number | null;
  birthDate?: string | null;
  createdById: string;
  custSampleNum?: string | null;
  groupNum?: number | null;
  jobId: string;
  participantData?: string | null;
  proctorId: string;
  sampleId?: string | null;
  sex?: string | null;
  siteId: string;
  testDateTime?: string | null;
  zip?: string | null;
};
export type CreateParticipantMutation$data = {
  readonly createParticipant: {
    readonly age: number | null;
    readonly birthDate: string | null;
    readonly createdById: string;
    readonly custSampleNum: string | null;
    readonly groupNum: number | null;
    readonly id: string;
    readonly job: {
      readonly id: string;
      readonly key: string;
    } | null;
    readonly jobId: string | null;
    readonly participantData: string | null;
    readonly proctorId: string | null;
    readonly sampleId: string | null;
    readonly sex: string | null;
    readonly site: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly siteId: string;
    readonly testDateTime: string | null;
    readonly zip: string | null;
  };
};
export type CreateParticipantMutation = {
  response: CreateParticipantMutation$data;
  variables: CreateParticipantMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "age"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "birthDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdById"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "custSampleNum"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupNum"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jobId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "participantData"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "proctorId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sampleId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sex"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteId"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "testDateTime"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "zip"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "age",
            "variableName": "age"
          },
          {
            "kind": "Variable",
            "name": "birthDate",
            "variableName": "birthDate"
          },
          {
            "kind": "Variable",
            "name": "createdById",
            "variableName": "createdById"
          },
          {
            "kind": "Variable",
            "name": "custSampleNum",
            "variableName": "custSampleNum"
          },
          {
            "kind": "Variable",
            "name": "groupNum",
            "variableName": "groupNum"
          },
          {
            "kind": "Variable",
            "name": "jobId",
            "variableName": "jobId"
          },
          {
            "kind": "Variable",
            "name": "participantData",
            "variableName": "participantData"
          },
          {
            "kind": "Variable",
            "name": "proctorId",
            "variableName": "proctorId"
          },
          {
            "kind": "Variable",
            "name": "sampleId",
            "variableName": "sampleId"
          },
          {
            "kind": "Variable",
            "name": "sex",
            "variableName": "sex"
          },
          {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "siteId"
          },
          {
            "kind": "Variable",
            "name": "testDateTime",
            "variableName": "testDateTime"
          },
          {
            "kind": "Variable",
            "name": "zip",
            "variableName": "zip"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "Participant",
    "kind": "LinkedField",
    "name": "createParticipant",
    "plural": false,
    "selections": [
      (v13/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Job",
        "kind": "LinkedField",
        "name": "job",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdById",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Site",
        "kind": "LinkedField",
        "name": "site",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "siteId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sampleId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "custSampleNum",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sex",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "groupNum",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "testDateTime",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "birthDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "age",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "zip",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "participantData",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "proctorId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateParticipantMutation",
    "selections": (v14/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v2/*: any*/),
      (v10/*: any*/),
      (v8/*: any*/),
      (v3/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v11/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v12/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateParticipantMutation",
    "selections": (v14/*: any*/)
  },
  "params": {
    "cacheID": "b706b55e77805a9025c205834610e95c",
    "id": null,
    "metadata": {},
    "name": "CreateParticipantMutation",
    "operationKind": "mutation",
    "text": "mutation CreateParticipantMutation(\n  $jobId: ID!\n  $createdById: ID!\n  $siteId: ID!\n  $sampleId: String\n  $custSampleNum: String\n  $sex: String\n  $groupNum: Int\n  $testDateTime: String\n  $birthDate: String\n  $age: Int\n  $zip: String\n  $participantData: String\n  $proctorId: ID!\n) {\n  createParticipant(input: {jobId: $jobId, createdById: $createdById, siteId: $siteId, sampleId: $sampleId, custSampleNum: $custSampleNum, sex: $sex, groupNum: $groupNum, testDateTime: $testDateTime, birthDate: $birthDate, age: $age, zip: $zip, participantData: $participantData, proctorId: $proctorId}) {\n    id\n    job {\n      id\n      key\n    }\n    createdById\n    site {\n      id\n      name\n    }\n    jobId\n    siteId\n    sampleId\n    custSampleNum\n    sex\n    groupNum\n    testDateTime\n    birthDate\n    age\n    zip\n    participantData\n    proctorId\n  }\n}\n"
  }
};
})();

(node as any).hash = "4a7a5aee425f7395d8698cb1f254ee89";

export default node;
